var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Controls"},[_c('span',{staticStyle:{"margin-right":"16px"}},[_vm._v(_vm._s(_vm.createName))]),_c('span',[_vm._v(_vm._s(_vm.items.createDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }